import styled from 'styled-components';
import { Box, Modal } from '@landr/maestro';

const SweetenerModal = styled(Modal)`
    width: 480px;
`;

const ModalContent = styled(Modal.Content)`
    display: flex;
    flex-direction: column;
`;

const ContentContainer = styled(Box)`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 0 20px;

    ${({ theme }): string => theme.breakpoint('sm')`
        margin-top: 0;  
    `}
`;

const HeaderContainer = styled(Box)`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
`;

const TextContainer = styled(Box)`
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    flex-direction: column;
`;

export const Styled = {
    SweetenerModal,
    ModalContent,
    ContentContainer,
    HeaderContainer,
    TextContainer,
};
